'use client';

import clsx from 'clsx';
import { HomeEnIcon } from '@/components/icons/svg-icons';
import { ScoreItem } from '@/services/scoreboard.service';
import { MatchTeamDot } from './match-team-dot';
import { useAtomValue } from 'jotai';
import { oddsPageAtom, sideMatchAtom } from '@/atoms/odds-page';
import { SportMatchModel } from '@nf/types/odds';
import { useParams } from 'next/navigation';
import { TeamLogo } from '@/features/odds-page/components/team-logo';

type TeamProps = {
	imgType: 'H' | 'A';
	name: string;
	score?: string;
	className?: string;
	scoreList?: ScoreItem[];
	sportId: number;
};

export const Team = ({ imgType, name, score, className, scoreList, sportId }: TeamProps) => {
	const params = useParams();
	const oddsData = useAtomValue(oddsPageAtom);
	let sideMatch = useAtomValue(sideMatchAtom) as SportMatchModel;
	sideMatch = !params.matchId ? sideMatch : oddsData?.MatchCollection?.find(match => match.MatchId === Number(params.matchId)) as SportMatchModel;
	const teamId = imgType === 'H' ? sideMatch?.TeamId1 : sideMatch?.TeamId2;

	const teamLabel = () => {
		return imgType === 'H' ? <div className="team__label"><HomeEnIcon /><div /></div> : null;
	};

	const teamScore = () => {
		return score ? <div className={clsx('vs__score-text', className)}>{score}</div> : null;
	};

	return (
		<div className="team">
			<div className="team__flag">
				{teamLabel()}
				<TeamLogo 
					teamType={imgType}
					teamId={teamId}
				/>
			</div>
			<div
				className="team__name"
				title={name}
			>
				{sportId === 44 && <MatchTeamDot variant={imgType === 'H' ? 'red' : 'blue'} />}
				{name}
			</div>
			{scoreList ?
				scoreList.map((item, index) => {
					return (
						<div className={item.isPlay ? 'vs__score-text' : 'vs__score-text vs__score-text--disable'} key={index}>
							{item.text}
						</div>
					)
				}) : teamScore()
			}
		</div>
	);
};
